export function svgStrToDataUrl(svgStr: string) {
  const imageContent = encodeURIComponent(svgStr)
  return `data:image/svg+xml;utf8,${imageContent}`
}

export function formatSvgStr(image: string, className?) {
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(image, 'image/svg+xml');
  const svgElement = svgDoc.documentElement;
  svgElement.setAttribute('preserveAspectRatio', 'none');
  svgElement.setAttribute('style', 'overflow: visible;width: 100%;height:100%;')
  svgElement.removeAttribute('width')
  svgElement.removeAttribute('height')
  if (className) {
    svgElement.setAttribute('class', className)
  }
  return svgElement.outerHTML.toString();
}